import reducer from './claim-details.reducer';

export { default as claimDetailsPageSelectors } from './claim-details.selectors';
export { claimDetailsSaga } from './claim-details.saga';
export default reducer;
